import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import history from "./history";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import PrivateRouter from "./hoc/PrivateRouter";
import SignIn from "./pages/SignIn";
import "antd/dist/antd.css";
import "../src/assets/scss/app.scss";
import { Provider } from "react-redux";
import { isAuthenticated } from "./utils";
import uscText from "../src/assets/images/usc_online_text.svg";
import { Helmet } from "react-helmet";
import { store } from "./redux/store";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./ErrorFallback";
import NotFound from "./pages/NotFound";
import SSOLog from "./pages/SSO_Log";
import PublicRouter from "./hoc/PublicRouter";

if (process.env.REACT_APP_FRONT_URL === "https://skillup.online.usc.edu") {
  console.log = () => {};
  // console.error = () => { }
  // console.debug = () => { }
}


ReactDOM.render(
  <>
    <Provider store={store}>
      <Router history={history}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <div className="top_header">
            <img
              src={uscText}
              onClick={() => history.push("/")}
              alt="USC Online"
              className="cursor_pointer"
            />
          </div>
          <Switch>
            <App history={history}>
              <Switch>
                <Route
                  exact
                  path="/"
                  render={(props) =>
                    !isAuthenticated() ? (
                      <>
                        <Helmet>
                          <title>{"SignIn"}</title>
                        </Helmet>
                        <SignIn {...props} sign="abc" />
                      </>
                    ) : (
                      <Redirect
                        to={{
                          pathname: "/users",
                          user: isAuthenticated,
                          state: { from: props.location },
                        }}
                      />
                    )
                  }
                />
                <Route
                  exact
                  path="/sso-log"
                  render={(props) =>
                    isAuthenticated() ? (
                      <>
                        <Helmet>
                          <title>{"SSO"}</title>
                        </Helmet>
                        <SSOLog />
                      </>
                    ) : (
                      <Redirect
                        to={{
                          pathname: "/",
                          user: isAuthenticated,
                          state: { from: props.location },
                        }}
                      />
                    )
                  }
                />
                {PublicRouter()}
                {PrivateRouter()}
                <Route>
                  <NotFound history={history} />
                </Route>
              </Switch>
            </App>
          </Switch>
        </ErrorBoundary>
      </Router>
    </Provider>
  </>,
  document.getElementById("root")
);

reportWebVitals();
